import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import Router from './routes';

// Brand tokens + shadcn primitive styles compiled by @tailwindcss/vite.
// Scans the shared-ui package's JSX via @source inside the CSS file.
import '@workingfeedback/shared-ui/style.css';

// Tailwind styles for the embedded feedback form (separate @source scope).
import '@workingfeedback/react-feedback-forms/style.css';

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <BrowserRouter>
            <Router />
        </BrowserRouter>
    </StrictMode>
);
